/**
 * URL helpers. Pure — no DOM, no globals — so they unit-test in node.
 */

/**
 * Rewrite a path to a new locale prefix, preserving the rest.
 *
 *   ('/he/', 'de')            -> '/de/'
 *   ('/de/reaktionstest','es')-> '/es/reaktionstest'
 *   ('/', 'ja')               -> '/ja/'
 *
 * @param {string} pathname current path
 * @param {string} locale   target locale
 * @param {string[]} locales supported locales, used to spot an existing prefix
 */
export function urlForLocale(pathname, locale, locales) {
  const segments = String(pathname || '/')
    .split('/')
    .filter(Boolean);

  const hasPrefix = segments.length > 0 && locales.includes(segments[0]);
  const rest = hasPrefix ? segments.slice(1) : segments;

  return `/${[locale, ...rest].join('/')}${rest.length === 0 ? '/' : ''}`;
}
